module.exports = __webpack_public_path__ + "src/assets/individualImages/workerIcon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/workerIcon.png
// module id = ./src/assets/individualImages/workerIcon.png
// module chunks = 0